var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MiniFooter',{scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('li',{staticClass:"list-inline-item"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Terms of Use")])])]},proxy:true},{key:"right",fn:function(){return [_vm._v(" © "+_vm._s(new Date().getFullYear())+" coflow, All rights reserved ")]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }